    // 颜色选择
    let imgArr = [
     
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/37.png?v=1739178015',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/39_48573e82-207f-4261-b59a-3ba7ec5604ce.png?v=1739867315',
       'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/40_abf10364-6507-4673-8c90-7ebe3515b7ed.png?v=1739867315',
      //  'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/lQLPJwoji7OTcw3NAljNA9SwyvZm5_vITWcJgP2wDG3VAg_980_600.png?v=1772706031',
      //  'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/lQLPJxE-iP0gcw3NAljNA9Sw6MCMJrKXuOYJgP2wDG3VAA_980_600.png?v=1772706031',
      //  'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/lQLPKGQsVF69Eg3NAljNA9SwmKFunxlwg_IJgP2wDG3VAQ_980_600.png?v=1772706031',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/20260316__img__US.jpg?v=1773626173',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/20260316__img__EU.jpg?v=1773626173',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/20260316__img__UK.jpg?v=1773626173',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/41_bb74faf8-a81e-4783-9bbe-7fe71b1b95e2.png?v=1739867315',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/43.png?v=1739178015',
    'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/44.png?v=1739178015',
    // 'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/lQLPJxvnBQdLVG3NAljNA9SwFYeH1_NAT30JgQBDaFXhAA_980_600.png?v=1772707026',
    // 'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/lQLPJv_WAvGRlG3NAljNA9SwT0uzYPQO8QsJgQBDaFXhAQ_980_600.png?v=1772707026',
    // 'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/lQLPJxxB-CnU_i3NAljNA9SwT5XB2oogfcYJgQFrWc5oAA_980_600.png?v=1772707025',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/20260316__img__US3.jpg?v=1773626173',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/20260316__img__EU3.jpg?v=1773626173',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/20260316__img__UK3.jpg?v=1773626173',

      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/46_80a7d98a-8276-4517-a2e9-d7c4366bc31c.png?v=1739867315',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/48_b05e469b-b585-4022-a950-33c3340bb45d.png?v=1739867315',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/49.png?v=1739178016',
      
      // 'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/lQLPJwp-ft_lFG3NAljNA9SwxESQTbrtxPkJgQBDaKovAQ_980_600.png?v=1772707026',
      //       'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/lQLPKGLAiD6hVG3NAljNA9SwegpTXkIOLwAJgQBDaKovAA_980_600.png?v=1772707026',
      // 'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/lQLPKHD2guPKvi3NAljNA9Sw846AsJn_OO8JgQFrWc5oAQ_980_600.png?v=1772707026',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/20260316__img__US5.jpg?v=1773626173',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/20260316__img__EU5.jpg?v=1773626173',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/20260316__img__UK5.jpg?v=1773626173',


      "https://cdn.shopify.com/s/files/1/0585/9596/7075/files/1_2.png?v=1770200226",
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/1_78472f7e-8cc4-4aa2-a060-f6e46a9b91d7.png?v=1770200226',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/1_21e8a7f3-0fec-4b3e-a116-b473c0f0a997.png?v=1770200226',
        "https://cdn.shopify.com/s/files/1/0585/9596/7075/files/2_1_2.png?v=1770200500",
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/2_1_6e1d7a1e-4385-49bb-adab-0174ccc1523b.png?v=1770200500',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/2_1.png?v=1770200500',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/3_2_2.png?v=1770200539',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/3_2.png?v=1770200539',
      'https://cdn.shopify.com/s/files/1/0585/9596/7075/files/3_2_0e971b8d-c7f7-4fba-b37e-de155e5dbb71.png?v=1770200539'
    ]
function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 变量
    funvar()
    function funvar() {
      var threshold = Number($('#new').html())
      if (threshold >= 60) {
        $('.sp-buynow').addClass('sp-red')
      } else {
        $('.sp-buynow').removeClass('sp-red')
      }
    }
    $(function () {
      $('.sp-part1-texts').arctext({
        radius: 500,
      })
    })
    // 初始化
    alignmentFns.initialize()
    // 数量

    let prods = window.product
    function getCur(){
      // let color = $('.sp-color-wraper li.active').attr('data-val')
      let size = $('.sp-chose-wraper li.active').attr('data-val')
      let num = $('#sp-size li.active').attr('data-val')
      //  let num1 = $('#sp-num1 li.active').attr('data-val')
      return prods.filter(item=>  item.option1 == size
        &&item.option2 == num
        // &&item.option3 == num1
      )[0]
    }
    function changePrice(){
      let num = $('#2').val()
      let price = (getCur().price * num / 100).toFixed(2)
      let compare = (getCur().compare_at_price * num / 100).toFixed(2)
      // if(num == 1){
      //   price = (getCur().price * num / 100).toFixed(2)
      // }else if(num == 2){
      //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
      // }else if(num == 3){
      //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
      // }else {
      //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
      // }
      // price = (price + '').replace('.', ',')
      // compare = (compare + '').replace('.', ',')
      $('#new').html(price)
      $('#old').html(compare)
      let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
      $(".sp-part5 .sp-prices .sp-clock span span").html(off_font);
    }
    $('.sp-buynow').click(function(){
      let num = $('#2').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })
    $('#addCart').click(function () {
      // do something here
      var data = {
        id: getCur().id,
        quantity: $('#2').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $(".sp-buy-car span").html(result.item_count);
          });
        },
        dataType: "json",
      });

      var img = $('.sp-pro-img img')
      var flyer = img[0].cloneNode(true)
      flyer.classList.add('clone')
      $('.sp-part5').append(flyer)
      $('.clone').css({
        width: img.width(),
        height: img.height(),
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })
      var offset = $('.sp-buy-car')[0].getBoundingClientRect()
      $('.sp-buy-car').addClass('shake')
      setTimeout(() => {
        $('.sp-buy-car').removeClass('shake')
      }, 1000)
      let finish = $('.sp-buy-car')
      $('.clone').animate(
        {
          top: finish[0].offsetTop + 117,
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        1000,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach() // 完成动画后移除克隆的图片
            }
          )
        }
      )
    })
    $('#2').change(function () {
      changePrice()
      funvar()
    })

    let textArr = window.options[0].values
    // $('.sp-color-wraper li').click(function () {
    //   $(this).addClass('active').siblings().removeClass('active')
    //   changeOption()
    //   changePrice()
    //   funvar()
    // })
    $('.sp-chose-wraper li').click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      changeOption()
      changePrice()
      funvar()
    })
    function changeOption() {
      var index = $('.sp-chose-wraper li.active').index()
      // const index2 = $('#sp-num1 li.active').index()
      const index2 = 0
      const num = $('#sp-size li.active').index()
      if(index2!=0){
        $(".sp-pro-img span").css({
          top: "530px",
          left: "275px",
        })
      }else{
        $(".sp-pro-img span").css({
          top: "526px",
          left: "670px",
        })
      }
      $(".sp-pro-img span").text($('#sp-num li.active').text())

      $('.sp-pro-img img').attr('src',imgArr[index + index2*3+num*6])
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    preloadImages(imgArr)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop + 5
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
